import axios from "axios"

const api = "delivery/ubicacion"

const ubicacion = {
    puntos: params => axios.get(`${api}/puntos`, { params })
}

export default ubicacion